import lodash from 'lodash'

import {
  IOrderEntryAddress,
  TOrderEntryFormValues,
  TOrderEntrySettings,
} from '../types'
import { fixAddress } from './addressUtils'
import getDefaultColi from './getDefaultColi'

function getDeliveryAddress({
  deliveryAddress,
  deliveryAddresses,
  customerAddress,
  defaultCountry,
}): IOrderEntryAddress {
  const address = !lodash.isEmpty(deliveryAddresses)
    ? lodash.first(deliveryAddresses)
    : customerAddress
  return fixAddress({
    country: defaultCountry || lodash.get(address, 'country'),
    ...(deliveryAddress === 'currentCustomer' ? address : deliveryAddress),
  })
}

function getPickupAddress({
  pickupAddress,
  customerAddress,
  defaultCountry,
}): IOrderEntryAddress {
  const address =
    pickupAddress === 'currentCustomer' ? customerAddress : pickupAddress
  return fixAddress({
    country: defaultCountry,
    ...address,
  })
}

function getInvoiceAddress({
  invoiceAddress,
  customerAddress,
  customerInvoiceAddress,
}): IOrderEntryAddress {
  return fixAddress({
    ...(invoiceAddress === 'currentCustomer'
      ? customerAddress
      : customerInvoiceAddress),
    isEdit: false,
  })
}

function getCustomsAddress({
  importaddress,
  customerAddress,
  customerImportAddress,
}): IOrderEntryAddress {
  return fixAddress({
    ...(importaddress === 'currentCustomer'
      ? customerAddress
      : customerImportAddress),
  })
}

// function updateWithUrlParams(values) {
//   // TODO:
//   return values
// }

// // only allowed values to come from outside (based on previous order etc)
// function trimInitialValues(values) {
//   const newValues = { ...values }
//   lodash.forEach(lodash.keys(newValues), (key) => {
//     if (['pickupAddress', 'deliveryAddress', 'unloadAddress', 'invoiceAddress'].includes(key)) {
//       lodash.set(newValues, key, lodash.pick(lodash.get(values, key), relevantAddressProps))
//     }
//   })
//   return newValues
// }

export default function getInitialValuesFromSettings({
  preset,
  currentCustomer,
  currentPrinter,
}: TOrderEntrySettings): TOrderEntryFormValues {
  // console.log('getInitialValuesFromSettings', { preset, currentCustomer })
  const {
    deliveryAddress,
    pickupAddress,
    invoiceAddress,
    importaddress,
    defaultSlaId,
    defaultSlaName,
    defaultWeight,
    defaultLength,
    defaultWidth,
    defaultHeight,
    isDeliveryAddressStatic,
    isPickupAddressStatic,
  } = preset
  const {
    defaultCurrency = 'EUR',
    returnAddresses = [],
    customerAddress,
    defaultCountry = 'CH',
    customerInvoiceAddress,
    senderAddresses = [],
    enableContactDataByDefault = false,
    customerImportAddress,
  } = currentCustomer || {}

  const deliveryAddresses = returnAddresses

  // TODO: set actual fill values

  const values = {
    customer: {
      address: fixAddress({
        country: defaultCountry,
        ...customerAddress,
      }),
    },
    delivery: {
      addresses: returnAddresses,
      address: {
        showContact: enableContactDataByDefault,
        ...getDeliveryAddress({
          deliveryAddress,
          customerAddress,
          deliveryAddresses,
          defaultCountry,
        }),
      },
      isEdit: !isDeliveryAddressStatic || !currentCustomer,
    },
    pickup: {
      addresses: senderAddresses,
      address: {
        showContact: enableContactDataByDefault,
        ...getPickupAddress({
          pickupAddress,
          customerAddress,
          defaultCountry,
        }),
      },
      isEdit: !isPickupAddressStatic || !currentCustomer,
    },
    invoice: {
      address: {
        showContact: enableContactDataByDefault,
        ...getInvoiceAddress({
          invoiceAddress,
          customerAddress,
          customerInvoiceAddress,
        }),
      },
    },
    importer: {
      address: {
        showContact: enableContactDataByDefault,
        ...getCustomsAddress({
          importaddress,
          customerAddress,
          customerImportAddress,
        }),
      },
    },
    colis: [
      getDefaultColi({
        defaultWeight,
        defaultLength,
        defaultWidth,
        defaultHeight,
      }),
    ],
    isPrintRequested: !!currentPrinter,
    // customsTerms: "ddp",
    isManualPricingEnabled: false,
    manualPricing: {
      currency: defaultCurrency,
      value: 0,
    },
    defaultSlaTypeId: defaultSlaId,
    defaultSlaTypeName: defaultSlaName,
    bookingRecords: [],
  }

  // detect initial pickup or delivery
  if (
    lodash.isEqual(
      lodash.get(values, 'pickup.address'),
      lodash.get(values, 'customer.address'),
    )
  ) {
    lodash.set(values, 'isDelivery', true)
  }
  if (
    lodash.isEqual(
      lodash.get(values, 'delivery.address'),
      lodash.get(values, 'customer.address'),
    )
  ) {
    lodash.set(values, 'isPickup', true)
  }

  return values
}
